import { createAction, createSelector, createSlice } from '@reduxjs/toolkit';
import { graphSelector } from './runtimeSlice';
import { selectedValuesSelector } from './selectionSlice';
import { createSliceSelector } from './utils/createSliceSelector';
export const setPopup = createAction('setPopup');
const initialState = null;
export const popupSlice = createSlice({
    name: 'popup',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(setPopup, (state, action) => action.payload);
    },
});
const popupSelector = createSliceSelector(popupSlice);
export const popupValueSelector = createSelector(popupSelector, graphSelector, selectedValuesSelector, (popup, graph, values) => {
    var _a;
    return popup === null || graph === null
        ? null
        : popup.type === 'node'
            ? Object.assign(Object.assign({ node: graph.nodes[popup.id], value: values === null ? null : (_a = values[popup.id]) !== null && _a !== void 0 ? _a : null }, popup), { type: 'node' }) : Object.assign(Object.assign({ edge: graph.edges[popup.id] }, popup), { type: 'edge' });
});
